//main.js собирается на webpack
import 'bootstrap'
import AOS from 'aos'
import 'jquery.maskedinput/src/jquery.maskedinput'
import 'slicknav/dist/jquery.slicknav.min'
import 'slick-carousel/slick/slick.min'
import './sass/main.scss'

$(document).ready(function () {
    var windowHeight = $(window).innerHeight();

    $('.usePhoneMask').mask("+375 (99) 999-99-99");

    function resizeTopSection() {
        windowHeight = $(window).innerHeight();
        if (windowHeight > 600 && $(window).width() > 992) {
            $('section.section--top').css('min-height', windowHeight);
            $('.section--top-info').css('padding-top', (windowHeight - $('.section--top-info').height()) / 2);
            $('.section--top-img img').css('padding-top', (windowHeight - $('.section--top-img img').height()) / 3 + 65);
        }
    }

    resizeTopSection();
    $(window).resize(function () {
        resizeTopSection();
    });


    $("body").on('click', 'a.scrollTo', function (e) {
        e.preventDefault();
        var element = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(element).offset().top - 50
        }, 1000);
    });
    AOS.init();
    $('.section--tabs-steps').on('click', '.btn', function (e) {
        e.preventDefault();
        var indexThisElement = $('.section--tabs-steps .btn').index($(this));
        $('.section--tabs-steps .btn').removeClass('active');
        $(this).addClass('active');
        $('.tabs-items-container .tabs-items').addClass('d-none');
        $('.tabs-items-container .tabs-items').eq(indexThisElement).removeClass('d-none');
    });

    $(window).scroll(function (e) {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).innerHeight();
        var opacity = scrollTop * 7 / windowHeight;
        $('.section--top-gragirnt').css('opacity', opacity >= 1 ? 1 : opacity)
       	$('header').css('top', scrollTop > windowHeight ? 0 : -300)
    })
    /*$('.carousel-parnters').slick({
        dots: true,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1
                }
            }
        ]
    });
    if ($(window).width() < 768) {
        $('#list-round').slick({
            arrows: false,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true,
            infinite: false,
            speed: 100,
            focusOnSelect: true
        });
        $('#list-round li').removeClass('leftToActive');
        $('#list-round').slick('slickGoTo', 3);
        $('#list-round').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $('#list-round li').removeClass('active');
            $('#list-round li.slick-center').addClass('active');
            var typePartner = $('.list-round li.slick-center').data("typeparther");
            $('.carousel-parnters').slick('slickUnfilter');
            $('.carousel-parnters').slick('slickFilter', '[data-typeparther=' + typePartner + ']');
            $('.carousel-parnters').slick('slickGoTo', 0);
            $('.slick-prev.slick-arrow').html('<svg><line x1="17" y1="0" x2="1" y2="21"></line> <line x1="0" y1="21" x2="21" y2="40"></line></svg>');
            $('.slick-next.slick-arrow').html('<svg><line x1="0" y1="0" x2="17" y2="21"></line> <line x1="17" y1="21" x2="0" y2="40"></line></svg>');
        });
    } else {
        $('.carousel-parnters').slick('slickFilter', '[data-typeparther=' + $('.list-round>li.active').data("typeparther") + ']');
        $('#list-round').on('click', '>li', function () {
            $('#list-round>li').removeClass('active');
            $(this).addClass('active');
            $('#list-round>li').removeClass('leftToActive');
            if ($(this).index() > 0) {
                $('#list-round>li').eq($(this).index() - 1).addClass('leftToActive')
            }
            var typePartner = $(this).data('typeparther');
            $('.carousel-parnters').slick('slickUnfilter');
            $('.carousel-parnters').slick('slickFilter', '[data-typeparther=' + typePartner + ']');
            $('.carousel-parnters').slick('slickGoTo', 0);
            $('.slick-prev.slick-arrow').html('<svg><line x1="17" y1="0" x2="1" y2="21"></line> <line x1="0" y1="21" x2="21" y2="40"></line></svg>');
            $('.slick-next.slick-arrow').html('<svg><line x1="0" y1="0" x2="17" y2="21"></line> <line x1="17" y1="21" x2="0" y2="40"></line></svg>');
        });

        $('#list-round>li').eq($('#list-round>li.active').index() - 1).addClass('leftToActive');
    }

    $('.carousel-banners').slick({
        dots: true
    });

    $('.slick-prev.slick-arrow').html('<svg><line x1="17" y1="0" x2="1" y2="21"></line> <line x1="0" y1="21" x2="21" y2="40"></line></svg>');
    $('.slick-next.slick-arrow').html('<svg><line x1="0" y1="0" x2="17" y2="21"></line> <line x1="17" y1="21" x2="0" y2="40"></line></svg>');
    */

    let activeBtn = document.querySelector('.active[data-typeparther]').dataset.typeparther
    let sortBtns = document.querySelectorAll('[data-typeparther]')
    let items = document.querySelectorAll('.item[data-typeparther]')

    window.onload = () => {
        items.forEach(item => {
            if(item.dataset.typeparther !== activeBtn) item.classList.add('hide')
        })
    }

    sortBtns.forEach(button => {
        button.onclick = () => {
            document.querySelector('.active[data-typeparther]').classList.remove('active')
            button.classList.add('active')
            activeBtn = button.dataset.typeparther
            items.forEach(item => {
                item.dataset.typeparther === activeBtn ?
                    item.classList.remove('hide') :
                    item.classList.add('hide')
            })
        }
    })

    $('.box-item').click(function () {
        $('.box-item').removeClass('active');
        $(this).addClass('active');
        $('.footer-box .container.body').addClass('d-none');
        $('.footer-box .container.body').eq($(this).index()).removeClass('d-none');
    });

    $(function () {
        $('header .header-nav').slicknav({
            'label': '',
            'appendTo': '.mobile-nav',
            'closeOnClick': true
        });
    });
    $('boby:not(header)').click(function (e) {
        $('header .header-nav').slicknav('close');
    });

    $('form[name="order-card"]').submit(function(event) {
        event.preventDefault();

        let inputs = $(this).find('input'),
            data = [],
            error = false,
            form = $(this);

        for(var i = 0;i < inputs.length;i++) {
            if($(inputs[i]).attr('id') !== 'check') {
                if ($(inputs[i]).attr('type') == 'checkbox') {
                    $(inputs[i]).parent().removeAttr('style');
                    if (!inputs[i].checked && $(inputs[i]).attr('name') !== 'processing_personal_data') {
                        $(inputs[i]).parent().css('color','#ff3600');
                        error = true;
                    } else if (inputs[i].checked)  {
                        data.push(inputs[i].value);
                    }
                } else {
                    $(inputs[i]).removeAttr('style');
                    if(inputs[i].value.length <= 0) {
                        error = true;
                        $(inputs[i]).css('border-color','#ff3600');
                    } else {
                        data.push(inputs[i].value);
                    }
                }
            }
        }

        if(!error) {
            $.ajax({
                url: '/local/components/newsite/lifestyle.form/ajax.php',
                data: {
                    data: JSON.stringify(data)
                },
                type: 'POST',
                success: function(data) {
                    $('#popup-form').text(data).show().animate({
                        'opacity':0.8
                    },300);

                    setTimeout(function() {
                        $('#popup-form').animate({
                            'opacity':0
                        },300);
                    },3000);

                    setTimeout(function() {
                        $('#popup-form').text('').hide();
                    },4000);
                },
                error: function(data) {
                    console.log(data)
                }
            })
        }
    });
});
